import * as React from 'react';

// components
import { BaseAskAQuestionUI, BaseAskAQuestionUIProps } from './AskAQuestionComponents';

// types
import { IConfigObj } from '@makemydeal/dr-common-utils';

const DESCRIPTION = 'Need to make some changes?';
const LINK_LABEL = 'Ask a Question';
const ICON_NAME = 'saveDeal';
const OUTER_CLASS_NAME = 'ask-a-question-panel';
const ID = 'ask-a-question-panel';
export const COUNTER_OFFER_TITLE = 'Respond to Dealer';
export const COUNTER_OFFER_DESCRIPTION =
    // eslint-disable-next-line max-len
    'If you are happy with the offer terms, let the dealer know by accepting this offer.  Otherwise, you can reach out to the dealer if you have any questions.';
export const COUNTER_OFFER_MOBILE_DESCRIPTION =
    'After you review your deal details, you can Accept it or respond to us with questions or changes.';

export type AskAQuestionUIStateProps = {
    alignment: string;
    borderDirection: string;
    isCountered?: boolean;
    isCounterOfferAccepted?: boolean;
    isCounterOffer?: boolean;
    isMobile: boolean;
    staticImages: IConfigObj;
};

export type AskAQuestionUIDispatchProps = {
    onAcceptDealClick: () => void;
    onClick: () => void;
};

export type AskAQuestionUIProps = AskAQuestionUIStateProps & AskAQuestionUIDispatchProps;

const AskAQuestionUI = ({
    staticImages,
    alignment,
    borderDirection,
    onClick,
    onAcceptDealClick,
    isCountered,
    isCounterOffer,
    isCounterOfferAccepted,
    isMobile
}: AskAQuestionUIProps) => {
    const getDescription = () => {
        if (isCountered) {
            return '';
        } else if (!isCounterOffer) {
            return DESCRIPTION;
        } else {
            return isMobile ? COUNTER_OFFER_MOBILE_DESCRIPTION : COUNTER_OFFER_DESCRIPTION;
        }
    };

    const props: BaseAskAQuestionUIProps = {
        id: ID,
        isCountered,
        isCounterOfferAccepted,
        onClick,
        onAcceptDealClick,
        alignment,
        staticImages,
        borderDirection,
        iconName: ICON_NAME,
        linkLabel: LINK_LABEL,
        outerClassName: OUTER_CLASS_NAME,
        counterOfferTitle: isCounterOffer ? COUNTER_OFFER_TITLE : '',
        description: getDescription(),
        isMobile
    };

    return <BaseAskAQuestionUI {...props} />;
};

export default AskAQuestionUI;
